function updateSlideAccessibility(firstSlide: HTMLDivElement) {
    updateSlideChildren(firstSlide);
    let nextSlide = firstSlide.nextElementSibling;

    while (nextSlide) {
        updateSlideChildren(nextSlide as HTMLDivElement);
        nextSlide = nextSlide.nextElementSibling;
    }

    function updateSlideChildren(slide: HTMLDivElement) {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
        const focusableChildren = slide.querySelectorAll(
            "a, button"
        ) as NodeListOf<HTMLAnchorElement | HTMLButtonElement>;
        const slideIsHidden = slide.getAttribute("aria-hidden") === "true";

        focusableChildren.forEach((el) =>
            slideIsHidden
                ? el.setAttribute("tabindex", "-1")
                : el.removeAttribute("tabindex")
        );
    }
}

export { updateSlideAccessibility };
